import { GridColDef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { GKClientDataGrid, Grid2 } from "components";
import dayjs from "dayjs";
import DashboardLayout from "layouts/DashboardLayout";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

const Inquiry = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["CONTACT_US"],
    queryFn: () => axiosInstance.get(`/contact-us/`),
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("First Name", "firstName", 100, 1),
    },
    {
      ...extraColumnsField("Last Name", "lastName", 100, 1),
    },
    {
      ...extraColumnsField("Company Name", "companyName", 100, 1),
    },
    {
      ...extraColumnsField("Message", "message", 100, 1),
    },
    {
      ...extraColumnsField("Reason", "reason", 100, 1),
    },
    {
      ...extraColumnsField("Platform", "platform", 100, 1),
    },
    {
      ...extraColumnsField("Date", "createdAt", 100, 1),
      valueGetter: (row) => dayjs(row?.row?.createdAt).format("DD/MM/YYYY"),
    },
  ];
  return (
    <DashboardLayout title="Inquiry">
      <Grid2 size={12}>
        <GKClientDataGrid
          columns={columns}
          rows={data?.data?.data || []}
          loading={isLoading}
          showFiltersButton={false}
        />
      </Grid2>
    </DashboardLayout>
  );
};

export default Inquiry;
